export enum ResultState {
  // The dialog provides a custom component which may not
  // contain a generic result such as closed, cancelled or confirmed.
  Custom,

  // The dialog was closed without any decision.
  Closed,

  // The dialog was cancelled.
  Cancelled,

  // The dialog was confirmed.
  Confirmed,
}
